import { Box, Button, styled, Typography } from "@mui/material"
import { colors } from "../../../theme/colors"

export const ContentContainer = styled(Box)({
  display: "flex",
  flexDirection: "column",
  flex: 1,
})

export const TopContainer = styled(Box)({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  textAlign: "center",
  marginTop: "auto",
  marginBottom: "auto",
})

export const SourceDescription = styled(Typography)({
  color: colors.lightBlack,
  fontSize: 22,
  lineHeight: "24px",
  marginTop: 30,
  fontWeight: 500,
})

export const IconContainer = styled(Box)({
  width: "100%",
  display: "flex",
  justifyContent: "center",
  marginTop: "auto",
})

export const ButtonsContainer = styled(Box)({
  display: "flex",
  flexDirection: "column",
  width: "100%",
})

export const StyledButton = styled(Button)({
  marginTop: 10,
  minHeight: 54,
  width: "100%",
})
